import React, { useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";
import { Loader2, Truck } from "lucide-react";

const AdminLogin = () => {
  const { user, login, loading } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const location = useLocation();

  if (loading) return <div className="p-12 text-center text-muted-foreground">Loading…</div>;
  if (user) return <Navigate to="/admin" replace state={{ from: location }} />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email.trim().toLowerCase(), password);
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted px-4 py-12">
      <form onSubmit={submit} className="w-full max-w-md rounded-sm border border-border bg-card p-8 shadow-sm" data-testid="admin-login-form">
        <div className="flex items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-sm bg-secondary text-secondary-foreground">
            <Truck className="h-5 w-5" />
          </span>
          <span className="font-display text-lg font-black uppercase">Fast Junk Pros</span>
        </div>
        <h1 className="mt-6 font-display text-3xl font-black">Dispatcher Login</h1>
        <p className="mt-2 text-sm text-muted-foreground">Admin access only.</p>
        <div className="mt-6 space-y-4">
          <div>
            <label className="mb-2 block text-sm font-semibold">Email</label>
            <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" required className="w-full rounded-sm border border-input bg-white px-4 py-3 outline-none focus:border-primary focus:ring-2 focus:ring-primary/40" data-testid="admin-email-input" />
          </div>
          <div>
            <label className="mb-2 block text-sm font-semibold">Password</label>
            <input value={password} onChange={(e) => setPassword(e.target.value)} type="password" required className="w-full rounded-sm border border-input bg-white px-4 py-3 outline-none focus:border-primary focus:ring-2 focus:ring-primary/40" data-testid="admin-password-input" />
          </div>
          <button type="submit" disabled={busy} className="btn-cta w-full disabled:opacity-50" data-testid="admin-login-submit">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : null}
            Sign In
          </button>
        </div>
      </form>
    </div>
  );
};

export default AdminLogin;
